import Typography from '@material-ui/core/Typography'
import { LabelValueMetadata } from '@mdz/mirador/dist/es/src/components/LabelValueMetadata'
import { PluginHook } from '@mdz/mirador/dist/es/src/components/PluginHook'
import CollapsibleSection from '@mdz/mirador/dist/es/src/containers/CollapsibleSection'
import SanitizedHtml from '@mdz/mirador/dist/es/src/containers/SanitizedHtml'
import PropTypes from 'prop-types'
import React, { Component } from 'react'

/**
 * Customized ManifestInfo that moves the description to the bottom of the panel and
 * shifts the location info to the top, otherwise identical to the upstream ManifestInfo component.
 *
 * Upstream code was taken from here: https://github.com/ProjectMirador/mirador/blob/v3.3.0/src/components/ManifestInfo.js
 */
export default class MdzManifestInfo extends Component {
  /**
   * this function currently shifts the Location information to the top of the metadata array.
   * @param manifestMetadata
   * @returns {manifestMetadata intact (if no locations) or sortedManifestMetadata}
   */
  getSortedLabelValuePairs = (manifestMetadata) => {
    const { t } = this.props
    const locations = manifestMetadata.find((m) => m.label === t('location'))
    if (locations) {
      return [
        locations,
        ...manifestMetadata.filter((m) => m.label !== t('location')),
      ]
    }
    return manifestMetadata
  }

  /**
   * render
   * @return
   */
  render() {
    const { manifestDescription, manifestLabel, manifestMetadata, id, t } =
      this.props

    return (
      <>
        <CollapsibleSection id={`${id}-resource`} label={t('resource')}>
          {manifestLabel && (
            <Typography
              aria-labelledby={`${id}-resource ${id}-resource-heading`}
              id={`${id}-resource-heading`}
              variant="h4"
              component="h5"
            >
              {manifestLabel}
            </Typography>
          )}

          {manifestMetadata.length > 0 && (
            <LabelValueMetadata
              labelValuePairs={this.getSortedLabelValuePairs(manifestMetadata)}
            />
          )}

          <PluginHook {...this.props} />
        </CollapsibleSection>

        {manifestDescription && (
          <CollapsibleSection id={`${id}-description`} label={t('description')}>
            <Typography variant="body1">
              <SanitizedHtml htmlString={manifestDescription} ruleSet="iiif" />
            </Typography>
          </CollapsibleSection>
        )}
      </>
    )
  }
}

MdzManifestInfo.propTypes = {
  id: PropTypes.string.isRequired,
  manifestDescription: PropTypes.string,
  manifestLabel: PropTypes.string,
  manifestMetadata: PropTypes.array,
  t: PropTypes.func,
}

MdzManifestInfo.defaultProps = {
  manifestDescription: null,
  manifestLabel: null,
  manifestMetadata: [],
  t: (key) => key,
}
